import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminSidebar from '../components/AdminSidebar';
import MessagesSection from '../components/MessagesSection';
import LanguageToggle from '../components/LanguageToggle';
import PageIntro from '../components/PageIntro';
import { getPageIntro } from '../lib/pageIntros';
import { useLanguage } from '../contexts/LanguageContext';
import { LogOut } from 'lucide-react';

const AdminMessagesPage = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('cop31_ultra_token');
  const { language } = useLanguage();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/giris');
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <AdminSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top bar */}
        <div className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between flex-shrink-0">
          <h1 className="text-xl font-bold text-gray-800">Müşteri Mesajları</h1>
          <div className="flex items-center gap-3">
            <LanguageToggle />
            <button
              onClick={handleLogout}
              className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-red-500 transition-colors"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
        <div className="px-4 pt-4">
          <PageIntro {...getPageIntro('messages', language)} />
        </div>
        {/* Chat area */}
        <div className="flex-1 overflow-hidden bg-white m-4 rounded-2xl border border-gray-100 shadow-sm">
          <MessagesSection token={token} />
        </div>
      </div>
    </div>
  );
};

export default AdminMessagesPage;
